module.exports = __webpack_public_path__ + "static/media/mapMarker.bab9fc14.svg";